/**
 * Script parsing helpers shared by the voice engine.
 *
 * Guided scripts use the token `{pause}` to mark a silent pause between
 * spoken passages.
 */

export type ScriptStep =
  | { type: 'text'; text: string; index: number }
  | { type: 'pause' };

/** Split a script into ordered steps, preserving pauses. */
export function parseScript(script: string): ScriptStep[] {
  const raw = script.split('{pause}');
  const steps: ScriptStep[] = [];
  let textIndex = 0;

  raw.forEach((chunk, i) => {
    const text = chunk.trim();
    if (text) {
      steps.push({ type: 'text', text, index: textIndex++ });
    }
    if (i < raw.length - 1) {
      steps.push({ type: 'pause' });
    }
  });

  return steps;
}

export function countTextSegments(script: string): number {
  return parseScript(script).filter((step) => step.type === 'text').length;
}
